import React from "react";
import styles from "./things-hub-drag-and-drop.module.scss";
import cn from "classnames";
import activateDragModeIcon from "@src/assets/svg/activate-drag-mode.svg";
import activateDragModeIconBlue from "@src/assets/svg/activate-drag-mode-blue.svg";
import { ToolTip } from "@src/components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";

const cssClassName = "things-hub-drag-and-drop";

interface ThingsHubDragAndDropProps {
  setIsDragMode: React.Dispatch<React.SetStateAction<boolean>>;
  isDragMode: boolean;
}

export const ThingsHubDragAndDrop = ({
  setIsDragMode,
  isDragMode,
}: ThingsHubDragAndDropProps) => {
  const i18n = useI18N();
  const texts = {
    activateDragModeText: i18n(
      "modules.thingsHubDragAndDrop.activateDragModeText",
    ),
    deactivateDragModeText: i18n(
      "modules.thingsHubDragAndDrop.deactivateDragModeText",
    ),
    toggleDragModeAltText: i18n(
      "modules.thingsHubDragAndDrop.toggleDragModeAltText",
    ),
  };

  return (
    <div className={styles[`${cssClassName}`]}>
      <ToolTip
        content={
          isDragMode ? texts.deactivateDragModeText : texts.activateDragModeText
        }
        position="left"
      >
        <button
          className={cn(styles[`${cssClassName}__activate-drag-button`], {
            [styles[`${cssClassName}__activate-drag-button--active`]]:
              isDragMode,
          })}
          onClick={() => setIsDragMode(!isDragMode)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <img
            src={isDragMode ? activateDragModeIcon : activateDragModeIconBlue}
            alt={texts.toggleDragModeAltText}
          />
        </button>
      </ToolTip>
    </div>
  );
};
